module.exports = __webpack_public_path__ + "media/images/illustrations/gift-blue-ae902a44c0ec5f0e9a4b1c7ea261b8b2.svg";